import { ACH } from "../constants";
import { isValidEmail, containsNumericValue, scrollToElement } from "../helpers";
import { store } from "../store";
import { validateContact, validateName } from "./GlobalValidations";

export function validateCheckout() {

    const values = store.getState().donationCheckout;

    let errors = {};
    if (!values.donationAmount || !parseInt(values.donationAmount) > 0)
        errors.donationAmount = 'Donation amount can not be null';

    else if (values.donationAmount && (values.donationAmount).toString().length > 12)
        errors.donationAmount = 'Donation amount is too big';

    else if (validateName(values.userContactDetails.firstName, true)) {
        errors.userDetails = {};
        errors.userDetails.firstName = validateName(values.userContactDetails.firstName, true);
    }

    else if (validateName(values.userContactDetails.lastName, true)) {
        errors.userDetails = {};
        errors.userDetails.lastName = validateName(values.userContactDetails.lastName, true)
    }

    else if (!values.userContactDetails.email) {
        errors.userDetails = {};
        errors.userDetails.email = "Email can not be null"
    }

    else if (!values.userContactDetails.address) {
        errors.userDetails = {};
        errors.userDetails.address = "Address is required"
    }

    else if (values.userContactDetails.address && values.userContactDetails.address.length > 200) {
        errors.userDetails = {};
        errors.userDetails.address = "Address can not be more than 200 characters"
    }

    else if (validateContact(values.userContactDetails.contactNumber, true)) {
        errors.userDetails = {};
        errors.userDetails.contactNumber = validateContact(values.userContactDetails.contactNumber, true)
    }

    else if (!values.userContactDetails.country) {
        errors.userDetails = {};
        errors.userDetails.country = "Country is required"
    }

    else if (!values.userContactDetails.city) {
        errors.userDetails = {};
        errors.userDetails.city = "City is required"
    }

    else if (values.userContactDetails.city && values.userContactDetails.city.length > 50) {
        errors.userDetails = {};
        errors.userDetails.city = "City can not be more than 50 characters"
    }

    else if (values.userContactDetails.city && containsNumericValue(values.userContactDetails.city)) {
        errors.userDetails = {};
        errors.userDetails.city = "City can not contain numeric value"
    }

    else if (!isValidEmail(values.userContactDetails.email)) {
        errors.userDetails = {};
        errors.userDetails.email = "Email is invalid"
    }

    else if (!values.userContactDetails.countryState) {
        errors.userDetails = {};
        errors.userDetails.countryState = "Country state is required"
    }

    else if (!values.userContactDetails.zipCode) {
        errors.userDetails = {};
        errors.userDetails.zipCode = "Zip code is required"
    }

    else if (values.userContactDetails.zipCode && values.userContactDetails.zipCode.length > 10) {
        errors.userDetails = {};
        errors.userDetails.zipCode = "Zip code can not be more than 10 characters."
    }

    else if (!values.selectedPaymentMethod)
        errors.selectedPaymentMethod = "Payment method is required"

    else if ((values.selectedPaymentMethod == "bank-transfer" || values.selectedPaymentMethod == "cheque") && values.isRecurring)
        errors.selectedPaymentMethod = "Payment method is required"

    else if (values.selectedPaymentMethod == "bank-transfer" && !values.selectedBank.bank_id) {
        errors.paymentMethodDetails = {}
        errors.paymentMethodDetails.bank = "Bank is required"
    }

    else if (values.selectedPaymentMethod == "bank-transfer" && !values.bankSlip.attachment) {
        errors.paymentMethodDetails = {}
        errors.paymentMethodDetails.bankSlip = "Bank slip is required"
    }

    else if (values.selectedPaymentMethod == "cheque" && !values.chequeNumber) {
        errors.paymentMethodDetails = {}
        errors.paymentMethodDetails.cheque = "Cheque number is required"
    }

    else if (values.selectedPaymentMethod == ACH && !values.achMode) {
        errors.paymentMethodDetails = {}
        errors.paymentMethodDetails.ach = "Please choose how you'd like to pay via bank transfer"
    }

    else if (values.selectedPaymentMethod == ACH && !values.achPaymentReady) {
        errors.paymentMethodDetails = {}
        errors.paymentMethodDetails.ach = values.achMode == "manual"
            ? "Please enter your bank details"
            : "Please connect your bank to continue"
    }

    else if (values.makeGiftAidDonation && !values.sameBillingForGiftAid) {
        if (!values.giftAidBilling.country) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.country = "Country is required"
        }

        else if (!values.giftAidBilling.city) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.city = "City is required"
        }

        else if (values.giftAidBilling.city && containsNumericValue(values.giftAidBilling.city)) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.city = "City can not contain numeric value"
        }

        else if (!values.giftAidBilling.address) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.address = "Address is required"
        }

        else if (!values.giftAidBilling.zipCode) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.zipCode = "Zip code is required"
        }

        else if (!values.giftAidBilling.countryState) {
            errors.giftAidBilling = {};
            errors.giftAidBilling.countryState = "State is required"
        }
    }

    else if (values.doubleTheImpact && !values.corporateMatchEmployer)
        errors.corporateMatch = 'Employer name is required'

    scrollToErrorPosition(errors);

    return errors;
};

const scrollToErrorPosition = (errors) => {

    if (errors.donationAmount) scrollToElement("checkoutAmountSection");

    else if (errors.userDetails) scrollToElement("checkoutContactSection");

    else if(errors.paymentMethodDetails || errors.selectedPaymentMethod) scrollToElement("paymentSection");

    else if(errors.giftAidBilling) scrollToElement("giftAidAddress");

    else if(errors.corporateMatch) scrollToElement("corporateMatchSection");
}
